<template>
  <div>
    <McButton
      variant="primary"
      text="Aktifkan Addendum"
      icon="icon-outline_checkmark"
      @click="triggerModal"
    />

    <b-modal
      static
      title="Ubah Data?"
      ref="mc-modal-confirm"
      size="md"
      centered
      scrollable
      hide-header-close
    >
      <div>
        <p>
          Simpan perubahan sebagai
          <strong>Addendum {{ version?.addendum }}</strong>
          ?
        </p>
        <p>Berikan alasan perubahan kontrak</p>

        <FormulateInput
          ref="addendum-reason"
          type="textarea"
          v-model="addendumReason"
          validation="required"
          :disabled="isLoading"
          :help="true"
        />
      </div>

      <template #modal-footer="{ cancel }">
        <div class="d-flex mx-0">
          <McButton
            :disabled="isLoading"
            @click="cancel()"
            variant="secondary"
            class="me-2"
            text="Tidak"
          />
          <McButton
            :disabled="isLoading"
            @click="handleActivateAddendum"
            variant="primary"
            text="Ya"
          />
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import McButton from '@/components/McButton'

import * as Addendum from '@/services/rest-api/lib/contract/addendum'

export default {
  components: {
    McButton,
  },
  props: {
    version: {},
  },
  data() {
    return {
      isLoading: false,
      addendumReason: '',
    }
  },
  computed: {
    prefixUrl() {
      return {
        vendorId: this.$route.params.vendorId,
        contractId: this.$route.params.contractId,
        versionId: this.$route.params.versionId,
      }
    },
  },
  methods: {
    async handleActivateAddendum() {
      this.$refs['addendum-reason'].context.blurHandler()
      await this.$nextTick()
      const valid = this.$refs['addendum-reason'].context.isValid
      if (!valid) return

      this.isLoading = true
      const res = await Addendum.activate(this.prefixUrl, { note: this.addendumReason })

      if (!res || res.errors) {
        this.$mcToast.error('Terjadi kesalahan')
        this.isLoading = false
        return
      }

      this.$mcToast.success('Addendum berhasil diaktifkan')
      this.addendumReason = ''
      this.$refs['mc-modal-confirm'].hide()

      this.$router.push({
        name: 'Master Vendor Contract Detail',
        params: this.prefixUrl,
        query: { refetch: true },
      })

      this.isLoading = false
    },

    triggerModal() {
      this.$refs['mc-modal-confirm'].show()
    },
  },
}
</script>

<style lang="scss" scoped></style>
